import Box from '@mui/material/Box';
import GroupReferencePreview from '../../QuestionPreviews/GroupReferencePreview/GroupReferencePreview';
import TabToggleEditor from '../../../../../../TextEditor/TabToggleEditor';
import { updateQuestion } from '../../../../../../../store/actions/dataEntryTemplateGeneratorActions';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

const GroupReferenceQuestion = ({ question, onChangeAlert }) => {
  const { isActive, id, error, content = '' } = question;
  const [editorContent, setEditorContent] = useState(content || '');
  const [markdown, setMarkdown] = useState(content || '');
  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {
      id,
      content: markdown ? editorContent : '',
      markdown
    };

    dispatch(updateQuestion(payload));
    onChangeAlert();
  }, [editorContent, markdown]);

  return (
    <>
      {!isActive ? (
        <GroupReferencePreview question={question} markdown={markdown} />
      ) : (
        <Box sx={{ marginTop: '20px', maxWidth: '95%' }}>
          <TabToggleEditor
            content={editorContent}
            setContent={setEditorContent}
            setMarkdown={setMarkdown}
            markdown={markdown}
            error={error?.content}
          />
        </Box>
      )}
    </>
  );
};

export default GroupReferenceQuestion;
